import { useCallback } from "react";
import { useStore } from "react-redux";

import {
  getExistingWidgetNames,
  getExistingPageNames,
} from "legacy/selectors/sagaSelectors";
import { validateName } from "legacy/utils/helpers";
import { selectAllApiUnionNames } from "store/slices/apisShared/selectors";
import type { AppState } from "store/types";

const createNameValidator =
  (state: AppState) =>
  ({ currentName, name }: { currentName: string; name?: string }) => {
    const existingPageNames = getExistingPageNames(state);
    const existingWidgetNames = getExistingWidgetNames(state);
    const existingBothApiNames = selectAllApiUnionNames(state);

    // pages or apis must be case insensitively unique
    const isCurrentEntityPageOrApi = existingBothApiNames.includes(currentName);

    const invalidNames = [
      ...existingPageNames,
      ...existingWidgetNames,
      ...existingBothApiNames,
    ].filter((name) => name !== currentName);

    return validateName(name, invalidNames, false, isCurrentEntityPageOrApi);
  };

export default function useEntityNameValidator(currentName: string) {
  const store = useStore<AppState>();

  return useCallback(
    (name?: string) => {
      const state = store.getState();
      return createNameValidator(state)({
        currentName,
        name,
      });
    },
    [store, currentName],
  );
}
